
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/fluid-power-formulas",
      function () {
        return require("private-next-pages/en/fluid-power-formulas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/fluid-power-formulas"])
      });
    }
  